import { RouteConfig } from 'vue-router';

// import { Rules as CaslRules } from '../../../back/src/casl/casl.constants';
import BagsIndex from '../pages/bags/BagsIndex.vue';

const routes: RouteConfig[] = [
  {
    path: '/bags',
    name: 'BagsIndex',
    component: BagsIndex,
    meta: {
      icon: 'mdi-sack',
      // rules: [CaslRules.AmostraUtinga.listarProducao],
    },
  },
];

export default routes;
